import React from "react";
import { Badge } from "../../../../Badge";
import * as S from "./styles";

var MenuBadge = function MenuBadge(_ref) {
  var e = _ref.text,
      t = _ref.backgroundColor;
  return React.createElement(S.Container, null, React.createElement(Badge, {
    text: e,
    backgroundColor: t
  }));
};

export default MenuBadge;